var map = {
	"./Group 22302.png": 1352,
	"./avatar-christmas.webp": 1353,
	"./bottom-bg-christmas.webp": 1354,
	"./btn-active.png": 1355,
	"./content-deco-1.webp": 1356,
	"./content-deco-2.webp": 1357,
	"./content-deco-3.webp": 1358,
	"./content-deco-4.webp": 1359,
	"./deco-3.webp": 1360,
	"./deposit-icon.webp": 1361,
	"./home-icon-active.webp": 1362,
	"./home-icon.webp": 1363,
	"./live-icon-active.webp": 1364,
	"./live-icon.webp": 1365,
	"./master-bg.jpg": 1366,
	"./master-bg.webp": 1367,
	"./me-icon-active.webp": 1368,
	"./me-icon.webp": 1369,
	"./platform.png": 1370,
	"./platform.webp": 1371,
	"./promos-icon-active.webp": 1372,
	"./promos-icon.webp": 1373,
	"./promos.webp": 1374,
	"./service-christmas.webp": 1375,
	"./snowman.webp": 1376,
	"./sponsor-icon-active.webp": 1377,
	"./sponsor-icon.webp": 1378,
	"./title-deco-left.webp": 1379,
	"./title-deco-right.webp": 1380,
	"./tree.webp": 1381,
	"./vip-icon.webp": 1382,
	"./vip.webp": 1383,
	"./withdraw-icon.webp": 1384,
	"./wwr-img.webp": 1385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 121;